import { render, staticRenderFns } from "./payBox.vue?vue&type=template&id=ec4249da&scoped=true"
import script from "./payBox.vue?vue&type=script&lang=js"
export * from "./payBox.vue?vue&type=script&lang=js"
import style0 from "./payBox.vue?vue&type=style&index=0&id=ec4249da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4249da",
  null
  
)

export default component.exports